export interface ChartTooltipLine {
  label: string;
  value: string;
  color?: string;
}

/** Hover card shared by the finance charts */
export const ChartTooltip = ({
  title,
  lines,
}: {
  title: string;
  lines: ChartTooltipLine[];
}) => (
  <div className="flex min-w-36 flex-col gap-1 rounded-md border bg-popover px-3 py-2 text-xs text-popover-foreground shadow-md">
    <p className="font-semibold first-letter:uppercase">{title}</p>
    {lines.map((line) => (
      <p key={line.label} className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-1.5 text-muted-foreground">
          {line.color && (
            <span
              aria-hidden
              className="size-2 rounded-sm"
              style={{ background: line.color }}
            />
          )}
          {line.label}
        </span>
        <span className="font-medium tabular-nums">{line.value}</span>
      </p>
    ))}
  </div>
);
